import { ASResponse, SearchResponse } from "types/searchApi/response";
import {
  RECOMMENDED_PRODUCTS_POD_ID,
  RECOMMENDED_SUGGESTIONS_POD_ID,
} from "../utils/constants";
import { searchAPI } from "./config";

export interface ASReqOptions {
  noProducts?: number;
  noSuggestions?: number;
  noBrands?: number;
  userId?: string;
}
export const getUserIdParam = (userId?: string) =>
  userId ? `&userId=${userId}` : "";

//query params hardcoded into url because its a problem passing it into params object because of % in num_results_Search%20Suggestions
export const getAutosuggestResults = async (
  query: string,
  {
    noProducts = 6,
    noSuggestions = 4,
    noBrands = 4,
    userId,
  }: ASReqOptions = {},
) => {
  try {
    const res = await searchAPI().get<SearchResponse>(
      `/autosuggest/${query}?num_results_Products=${noProducts}&num_results_Brands=${noBrands}&num_results_Search%20Suggestions=${noSuggestions}${getUserIdParam(
        userId,
      )}`,
      { headers: { Accept: "application/json" } },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getRecommendedProducts = async (userId?: string, noProducts = 6) => {
  try {
    const res = await searchAPI().get<SearchResponse>(
      `/recommendations/${RECOMMENDED_PRODUCTS_POD_ID}?section=Products${getUserIdParam(
        userId,
      )}`,
      {
        headers: { Accept: "application/json" },
        params: { num_results: noProducts },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getRecommendedSuggestions = async (
  userId?: string,
  noSuggestions = 4,
) => {
  try {
    const res = await searchAPI().get<SearchResponse>(
      `/recommendations/${RECOMMENDED_SUGGESTIONS_POD_ID}?section=Search%20Suggestions${getUserIdParam(
        userId,
      )}`,
      {
        headers: { Accept: "application/json" },
        params: { num_results: noSuggestions },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getRecommendations = async ({
  userId,
  noProducts,
  noSuggestions,
}: Omit<ASReqOptions, "noBrands"> = {}): Promise<ASResponse | null> => {
  const [productsRes, suggestionsRes] = await Promise.all([
    getRecommendedProducts(userId, noProducts),
    getRecommendedSuggestions(userId, noSuggestions),
  ]);
  if (!productsRes || !suggestionsRes) return null;

  return {
    response: {
      product_list: productsRes.response.product_list,
      autosuggest: {
        suggestions: suggestionsRes.response.product_list.map((p) => p.title),
      },
      recs: {
        productsMeta: productsRes.response.meta,
        suggestionsMeta: suggestionsRes.response.meta,
        suggestionStrategyIds: suggestionsRes.response.product_list.map(
          (p) => p.meta.strategy.id,
        ),
      },
    },
  };
};
